import BrandbookConfigContext from 'brandbook/contexts/BrandbookConfig/BrandbookConfigContext'
import { useContext } from 'react'

const useBrandbookConfig = () => useContext(BrandbookConfigContext)

export default useBrandbookConfig
